import {PressArchiveOverviewEntryDto} from "../../dtos/press-archive-overview-entry-dto";
import {Utils} from "../../utils";

export class ItemRender{

	constructor(private container:HTMLElement){
	}

	public render(item:PressArchiveOverviewEntryDto){
		var entryHtml = document.createElement("div");
		var entryDescriptionHtml = document.createElement("div");
		var dateHtml = document.createElement("div");
		var typeHtml = document.createElement("div");
		var titleHtml = document.createElement("div");
		var subTitleHtml = document.createElement("div");
		var permalinkHtml = document.createElement("a");
		var imageHtml = document.createElement("img");

		entryHtml.classList.add("_entry");
		entryDescriptionHtml.classList.add("_entryDescription");
		titleHtml.classList.add("headline4");
		dateHtml.classList.add("_date");
		dateHtml.classList.add("titleMiniBold");
		typeHtml.classList.add("_type");
		typeHtml.classList.add("titleMini");
		subTitleHtml.classList.add("titleMini");

		entryHtml.appendChild(entryDescriptionHtml);
		if(item.title != null){
			titleHtml.innerHTML = item.title;
			permalinkHtml.appendChild(titleHtml);	
		}		
		if(item.image != null){
			imageHtml.src = item.image;
			entryHtml.appendChild(imageHtml);
		}	
		if(item.date != null){
			var date = new Date(item.date);
			dateHtml.innerHTML = date.getDate() + ". " + Utils.monthNamesShort[date.getMonth()] + " " + date.getFullYear();
			entryDescriptionHtml.appendChild(dateHtml);
		}
		if(item.type != null){
			typeHtml.innerHTML = item.type;
			entryDescriptionHtml.appendChild(typeHtml);
		}
		if(item.permaLink != null){
			permalinkHtml.href = item.permaLink;
		}
		entryDescriptionHtml.appendChild(permalinkHtml);

		if(item.subTitle != null){
			subTitleHtml.innerHTML = item.subTitle;
			entryDescriptionHtml.appendChild(subTitleHtml);
		}
		this.container.appendChild(entryHtml);
	}
}